import API_BASE_URL from "../config";
import { navigate } from "./navigationService";

const REFRESH_INTERVAL = 10 * 60 * 1000;
let tokenRefreshTimer = null;

export const storeTokens = (accessToken, refreshToken) => {
    console.log("🔐 Storing tokens:", accessToken, refreshToken); // add this
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    scheduleTokenRefresh();
  };
  

export const removeTokens = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

export const getAccessToken = () => localStorage.getItem('accessToken');
export const getRefreshToken = () => localStorage.getItem('refreshToken');

const scheduleTokenRefresh = () => {
  clearTimeout(tokenRefreshTimer);
  tokenRefreshTimer = setTimeout(() => {
    console.log('⏰ Refreshing access token...');
    refreshAccessToken();
  }, REFRESH_INTERVAL);
};

export const refreshAccessToken = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    console.warn('No refresh token. User must re-login.');
    return false;
  }

  try {
    const response = await fetch(`${API_BASE_URL}user/refreshToken`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token: refreshToken }),
    });

    if (!response.ok) throw new Error('Token refresh failed');

    const { accessToken, refreshToken: newRefreshToken } = await response.json();
    storeTokens(accessToken, newRefreshToken);
    console.log('🔁 Access token refreshed.');
    return true;
  } catch (error) {
    console.error('Error refreshing token:', error);
    removeTokens();
    navigate("/login");
    return false;
  }
};

export const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    navigate("/login"); // Redirect to login
  };